const facilityGroupPath = '/facility-groups';
export const getFacilityGroups = facilityGroupPath;
export const getFacilityGroupById = (id: number) => `${facilityGroupPath}/${id}`;
export const createFacilityGroup = facilityGroupPath;
export const updateFacilityGroup = (id: number) => `${facilityGroupPath}/${id}`;
export const getFacilityGroupQR = (id: number) => `${facilityGroupPath}/${id}/QR`;
export const updateFacilityGroupStatus = (id: number) => `${facilityGroupPath}/${id}/publishing`;

